import Styles from './InsertTableButton.module.scss'
import { useContext, useMemo, useState } from 'react'
import { InsertButton } from '../InsertButton/InsertButton'
import { insertTable } from '../../utils/insertTable'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { SingleMenuDropdownContext } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownStore'
import { Tables } from 'almanac-ui/icons/16'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'

const DEFAULT_ACTIVE_ROW = 2
const DEFAULT_ACTIVE_COLUMN = 2

export type TableSize = {
  rows: number
  columns: number
}

interface Props {
  isSubmenu?: boolean
}

export const InsertTableButton = ({ isSubmenu = false }: Props) => {
  const view = useEditorView()
  const columns = 6
  const rows = 4
  const [activeRow, setActiveRow] = useState<number>()
  const [activeColumn, setActiveColumn] = useState<number>()
  const isBoxActive = (rowIndex: number, columnIndex: number) => {
    if (activeRow === undefined || activeColumn === undefined) return false
    return rowIndex <= activeRow && columnIndex <= activeColumn
  }
  const dense_table = useFlipperFlag('dense_table')
  const dropdownStore = useContext(SingleMenuDropdownContext)

  const label = useMemo(() => {
    if (activeRow === undefined || activeColumn === undefined) return 'Table'
    return `Table ${activeColumn + 1}x${activeRow + 1}`
  }, [activeRow, activeColumn])

  const resetGrid = () => {
    setActiveRow(undefined)
    setActiveColumn(undefined)
  }

  const setDefaultGrid = () => {
    setActiveRow(DEFAULT_ACTIVE_ROW)
    setActiveColumn(DEFAULT_ACTIVE_COLUMN)
  }

  const insertSelectedTable = () => {
    if (activeRow === undefined || activeColumn === undefined) return
    insertTable(view, { rows: activeRow + 1, columns: activeColumn + 1 }, dense_table)
    dropdownStore?.hardClose()
  }

  const renderBox = (rowIndex: number, columnIndex: number) => {
    return (
      <div
        className={isBoxActive(rowIndex, columnIndex) ? Styles.tableSizeButton__active : Styles.tableSizeButton}
        key={columnIndex}
        onMouseEnter={() => {
          setActiveRow(rowIndex)
          setActiveColumn(columnIndex)
        }}
        onClick={() => {
          insertTable(view, { rows: rowIndex + 1, columns: columnIndex + 1 }, dense_table)
          dropdownStore?.hardClose()
        }}
      />
    )
  }

  const renderRow = (rowIndex: number) => {
    return (
      <div className={Styles.rowContainer} key={rowIndex}>
        {[...Array(columns)].map((empty, columnIndex) => renderBox(rowIndex, columnIndex))}
      </div>
    )
  }

  return (
    <InsertButton
      label={label}
      icon={isSubmenu ? undefined : <Tables />}
      mouseEnter={setDefaultGrid}
      mouseLeave={resetGrid}
      onClick={insertSelectedTable}
      isSubmenu={isSubmenu}
    >
      <div className={Styles.TableSizeSelector}>{[...Array(rows)].map((empty, rowIndex) => renderRow(rowIndex))}</div>
    </InsertButton>
  )
}
